import secondLevelMenu from './partials/second-level'
interface StyleProps {
    isAtTop: boolean
    isTransparentMode: boolean
    menuHeight: string
    showTopbarContent: boolean
}

const baseMenu = {
    HeaderMenu: {
        baseStyle: ({isAtTop, isTransparentMode, menuHeight, showTopbarContent}: StyleProps) => ({
            container: {
                minH: {base: 'full', lg: 'unset'},
                h: {base: `calc(100dvh - 81px)`, lg: 'unset'},
                pt: isAtTop && {lg: 'spacing.4'},
                justify: {base: showTopbarContent ? 'space-between' : 'flex-start', lg: 'center'},
                position: 'relative',
                alignItems: {base: 'center', md: 'flex-start', xl: 'center'},
                bg: {base: 'color.background.header.default', xl: isTransparentMode && 'transparent'},
            },
            navbar: {
                w: 'full',
                h: {base: !showTopbarContent && 'full', lg: 'auto'},
                position: 'relative',
                flexDirection: {base: 'column', lg: 'row'},
                justifyContent: {base: 'flex-start', lg: 'center'},
                alignItems: 'flex-start',
                minHeight: {lg: menuHeight},
                transition: 'min-height .3s ease-in-out',
                gap: {base: '0', lg: 'spacing.2'},
            },
            topbarContent: {
                w: 'full',
                py: 'spacing.4',
                background: 'color.background.grey.100',
                gap: 0,
            },
            firstLevelBox: {
                width: {base: '100%', lg: 'auto'},
                borderTop: {base: '1px solid', lg: 'none'},
                borderTopColor: 'color.border.grey.300',
                p: 0,
                pl: {base: 'spacing.6', lg: 0},
                pr: {base: 'spacing.6', lg: 0},
            },
            firstLevelItemBox: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                cursor: 'pointer',
            },
            firstLevelItemArrow: {
                visibility: {base: 'visible', lg: 'hidden'},
                display: {base: 'block', lg: 'none'},
            },
            focusArrow: {
                opacity: 0,
                _focus: {
                    opacity: 1,
                },
            },
            focusArrowActive: {
                transform: 'rotate(180deg)',
            },
        }),
    },
}

const menu = {
    ...baseMenu,
    ...secondLevelMenu,
}

export default menu
